import React, { Component } from 'react';
import queryString from 'query-string'
import { Redirect } from "react-router-dom"
import "./Button.scss"
import { handleLink } from '../../Services/Storage';

class Button extends Component {
    constructor(props) {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            Redirect: false
        }
    }
    handleClick() {
        if (!this.props.onClick) return;
        const parse = window.location.search ? queryString.parse(window.location.search) : "";
        handleLink.set(parse.s);
        this.setState({
            Redirect: true
        }, () => {
            window.setTimeout(() => this.setState({
                Redirect: false
            }), 500)  
        })
        if (typeof (window.history.pushState) == 'function') {
          window.history.pushState(null, `./`, `./`);
        }
        // this.props.onClick();
    }
    render() {
        if (this.state.Redirect) {
            return <Redirect to={this.props.onClick()} />
        }
        return (
            <div className={`button ${this.props.className}`} onClick={this.handleClick}>
                <div className="button-text">
                    {this.props.context}
                </div>
            </div>
        );
    }
}

export default Button;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Button/Button.jsx